<template>
  <el-dialog :visible.sync="visible" :width="width" :close-on-click-modal="false" :show-close="false"
    custom-class="order-success-dialog">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">🎉</div>
      </div>

      <h1 class="text-2xl font-bold mb-2">🎉 ¡Orden creada con éxito!</h1>
      <p class="text-gray-500 text-sm mb-6">{{ successMessage }}</p>

      <div class="bg-gray-50 rounded-xl p-4 mb-6 border border-gray-200 text-left">
        <div class="flex items-center justify-between mb-3">
          <span class="text-xs font-semibold text-blue-600 bg-blue-100 rounded-full px-2 py-1">{{ orderReference
            }}</span>
          <span class="text-xs text-gray-400">Hace un momento</span>
        </div>

        <div class="space-y-2">
          <div class="flex items-center gap-2 text-sm">
            <i class="bx bx-check-circle text-green-600"></i>
            <i class="bx bx-user text-gray-400"></i>
            <span>Cliente registrado</span>
          </div>
          <div class="flex items-center gap-2 text-sm">
            <i class="bx bx-check-circle text-green-600"></i>
            <i class="bx bx-mobile text-gray-400"></i>
            <span>Dispositivo agregado</span>
          </div>
          <div class="flex items-center gap-2 text-sm">
            <i class="bx bx-check-circle text-green-600"></i>
            <i class="bx bx-wrench text-gray-400"></i>
            <span>Servicio asignado</span>
          </div>
          <div class="flex items-center gap-2 text-sm">
            <i class="bx bx-check-circle text-green-600"></i>
            <i class="bx bx-dollar text-gray-400"></i>
            <span>Precio establecido</span>
          </div>
        </div>

        <div class="border-t border-gray-200 mt-4 pt-3 flex items-center justify-between text-xs">
          <span class="text-gray-500">Estado</span>
          <span class="text-orange-600 bg-orange-100 rounded-full px-2 py-1 font-semibold">Por asignar</span>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <el-button type="primary" size="large" class="w-full font-bold flex items-center justify-center gap-2"
          @click="toOrders">📋 Ver mis órdenes</el-button>

        <el-button size="large" class="w-full font-bold flex items-center justify-center gap-2 no-left-margin"
          @click="createAnother">
          ➕ Crear otra orden
        </el-button>

        <div class="mb-4">
          <div class="bg-purple-50 rounded-xl p-4 mb-3 border border-purple-100 text-left">
            <div class="flex items-start gap-4">
              <div>
                <div class="font-semibold text-sm mb-1">⚙️ ¿Listo para usar Samii en tu negocio real?</div>
                <div class="text-xs text-gray-600">Configura impuestos, logo, políticas, usuarios y otros ajustes
                  importantes para dejar tu sistema listo para producción.</div>
                <div class="my-3 text-center">
                  <el-button type="primary" size="small" @click="goToSettings" class="font-semibold">
                    Ir a configuración
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center text-sm text-gray-500 mt-2">
            <a href="#" class="hover:underline" @click.prevent="goToDashboard">Ir al dashboard →</a>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FourthStepOnboarding',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: '500px',
    },
    orderData: {
      type: Object,
      default: () => ({
        clientName: 'Cliente Demo',
        device: 'Dispositivo Demo',
        service: 'Servicio Demo',
        reference: 'ORD-0001',
        price: 0,
        isRealOrder: false,
      }),
    },
  },
  computed: {
    isRealOrder() {
      return this.orderData.isRealOrder || false;
    },
    orderReference() {
      return this.orderData.reference || 'ORD-0001';
    },
    successMessage() {
      if (this.orderData && typeof this.orderData === 'object') {
        return 'Así se verán todas tus órdenes en Samii.';
      }
      return this.isRealOrder ? 'Tu primer orden real ha sido registrada.' : 'Así se verán todas tus órdenes en Samii.';
    },
    visible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  methods: {
    toOrders() {
      this.$emit('orders');
    },
    createAnother() {
      this.$emit('create-another');
    },
    goToSettings() {
      this.$emit('goto-settings');
    },
    goToDashboard() {
      this.$emit('goto-dashboard');
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-success-dialog.el-dialog {
  border-radius: 12px;
  margin: 0 !important;
  top: 0 !important;
}

.order-success-dialog .el-dialog__header {
  display: none;
}

.order-success-dialog .el-dialog__body {
  padding: 0;
}

/* Override left margin for the specific button if any global rules add it */
.no-left-margin {
  margin-left: 0 !important;
}
</style>
